import scrollTo from './scrollTo';
import { isDesktopLarge } from './responsiveViewport';
var leftNavigatorTooltip = require('./leftNavigatorTooltip');

// Init the flying left menu (for report)
function initWooFlyingMenu () {
  let wooTopPos = 0;
  const $topTmp = $('#top');
  const $wooFlyingMenu = $('#flying');
  leftNavigatorTooltip();

  if ($topTmp.length > 0) {
    wooTopPos = $topTmp.offset().top;
  }

  // Catch the scroll event
  $(window).off('scroll');
  $(window).on('scroll', () => {
    // If scrollY greather than left menu top position -> move it
    const $leftNav = $('#left-nav');

    if ($leftNav.length) {
      const $rightPanel = $('#right-panel');
      const bodyHeight = $('body').height();
      const leftMenuHeight = $wooFlyingMenu.height();
      const defaultMargin = $('body').hasClass('no-header') ? 0 : 80; // -content.padding-top + #left-nav.margin-top
      const staticDifference = 130;
      const footerHeight = $('#footer').outerHeight();
      const scrollDifference = window.scrollY - $(document).height() + bodyHeight;
      const isScrolledToEnd = (
        scrollDifference - footerHeight + leftMenuHeight - staticDifference
        ) >= 0;
      const isDesktop = isDesktopLarge();

      const isEnoughSpace = (
        $(document).height() - window.scrollY - footerHeight - leftMenuHeight - staticDifference
        ) > 0;

      if (window.scrollY > $leftNav.offset().top - defaultMargin && $leftNav.offset().top >= 0) {
        $wooFlyingMenu.addClass('is-flying');

        if (isScrolledToEnd && !isEnoughSpace && isDesktop) {
          $wooFlyingMenu.css({
            'top': 'auto',
            'bottom': scrollDifference + footerHeight + defaultMargin
          });
        } else {
          $wooFlyingMenu.css({
            'top': '',
            'bottom': 'auto'
          });
        }

        if ($('body').hasClass('settings')) {
          $rightPanel.addClass('menu-is-flying');
        }

        const links = $wooFlyingMenu.find('.inpage-link:not(:hidden)');

        // Calcul current active link when it's an inpage menu
        if (links.length > 0) {
          // find the one currently in view
          let current = false;

          $(links).each((i, link) => {
            const $link = $(link);
            const linkHref = $link.attr('href');
            const offset = $(linkHref).offset() || 0;
            const margin = isDesktop ? defaultMargin : defaultMargin * 2;
            const screenPosition = window.scrollY + margin + wooTopPos;
            const topPosy = offset.top || 0;

            if (topPosy <= screenPosition) {
              current = $link;
              return current;
            }
          });

          // add corect class to current link
          links.removeClass('current');

          if (current) {
            return current.addClass('current');
          }
        }
      } else {
        $wooFlyingMenu.removeClass('is-flying');
      }
    }
  });

  // bind click on inpage links -> scrollTo when clicked
  $wooFlyingMenu.find('.inpage-link').on('click', function (event) {
    const currentHref = $(this).attr('href');
    let $element;

    event.preventDefault();

    if (isNaN(parseInt(currentHref, 10))) {
      $element = $(currentHref);
    } else {
      $element = $('.spied').eq(currentHref);
    }

    return scrollTo($element, 500);
  });
}

module.exports = initWooFlyingMenu;
